import React from 'react';
import { CategoryMenu } from '.';
import { CategoryLinkList } from './CategoryLinkList';
const formatColumnProps = (columnData) => {
    var _a, _b;
    return {
        eyebrow: (columnData === null || columnData === void 0 ? void 0 : columnData.fields.eyebrow) || '',
        categoryLink: ((_a = columnData === null || columnData === void 0 ? void 0 : columnData.fields.categoryLink) === null || _a === void 0 ? void 0 : _a.fields)
            ? {
                label: columnData.fields.categoryLink.fields.label,
                href: columnData.fields.categoryLink.fields.href,
                openInNewTab: columnData.fields.categoryLink.fields.openInNewTab,
                trackingLabel: columnData.fields.categoryLink.fields.trackingLabel,
                svgIcon: columnData.fields.categoryLink.fields.icon,
            }
            : { label: '', href: '', trackingLabel: '' },
        subLinks: ((_b = columnData === null || columnData === void 0 ? void 0 : columnData.fields.subLinks) === null || _b === void 0 ? void 0 : _b.map(link => ({
            label: (link === null || link === void 0 ? void 0 : link.fields.label) || '',
            href: (link === null || link === void 0 ? void 0 : link.fields.href) || '',
            openInNewTab: (link === null || link === void 0 ? void 0 : link.fields.openInNewTab) || false,
            trackingLabel: (link === null || link === void 0 ? void 0 : link.fields.trackingLabel) || '',
            svgIcon: (link === null || link === void 0 ? void 0 : link.fields.icon) || '',
        }))) || [],
    };
};
export const ContentfulCategoryMenu = ({ activeItem, }) => {
    return (React.createElement(CategoryMenu, { column1: React.createElement(CategoryLinkList, Object.assign({}, formatColumnProps(activeItem.fields.column1))), column2: React.createElement(CategoryLinkList, Object.assign({}, formatColumnProps(activeItem.fields.column2))), column3: React.createElement(CategoryLinkList, Object.assign({}, formatColumnProps(activeItem.fields.column3))), column4: React.createElement(CategoryLinkList, Object.assign({}, formatColumnProps(activeItem.fields.column4))) }));
};
//# sourceMappingURL=ContentfulCategoryMenu.js.map